import { Controller } from '@hotwired/stimulus'
import EasyMDE from 'easymde'
import * as ActiveStorage from '@rails/activestorage'
import 'easymde/dist/easymde.min.css'

// Turns the chapter body <textarea> into an EasyMDE Markdown editor. Images
// dropped/added via the toolbar are uploaded straight to R2 through Active
// Storage Direct Upload; on success we insert a `![](blob:SIGNED_ID)` token at
// the cursor, which the server later resolves to the attached blob. The upload
// endpoint arrives as a Stimulus value (`upload-url`) so the URL is built
// server-side (route helper) rather than hardcoded here. Auto-registered by the
// controllers glob.
export default class extends Controller {
  static values = { uploadUrl: String }

  connect() {
    this.editor = new EasyMDE({
      element: this.element,
      spellChecker: false,
      status: ['words'],
      toolbar: [
        'bold',
        'italic',
        'heading',
        'quote',
        'unordered-list',
        'ordered-list',
        'link',
        'image'
      ],
      // Upload via Active Storage Direct Upload, then hand EasyMDE the signed-id
      // token so it inserts `![](blob:SIGNED_ID)` at the cursor.
      imageUploadFunction: (file, onSuccess, onError) => {
        new ActiveStorage.DirectUpload(file, this.uploadUrlValue).create((error, blob) =>
          error ? onError(error) : onSuccess('blob:' + blob.signed_id)
        )
      }
    })
  }

  disconnect() {
    // Restore the plain <textarea> and drop the editor so a re-connect (e.g. a
    // Turbo cache restore) rebuilds it cleanly instead of stacking instances.
    if (this.editor) {
      this.editor.toTextArea()
      this.editor = null
    }
  }
}
